import React, { useEffect, useState } from "react";

import AccountingField from "../../components/shared/AccountingField";
import { makeStyles } from "@material-ui/core";
import { tokens } from "../../theme/tokens";

const useStyle = makeStyles((theme) => ({
  formikInput: {
    // color: theme.palette.primary.main,
    opacity: 1,
    color: `${tokens.color.text.primary} !important`,
    fontSize: "1em",
    // marginLeft: "1vh",
    // width: "50%",
    textAlign: "right",
    "& .MuiInputBase-input": {
      textAlign: "right",
    },
    "& ::-webkit-calendar-picker-indicator": {
      marginLeft: "0px",
    },
  },
}));

function AccountingHeader({ values, index }) {
  const classes = useStyle();
  return (
    <div style={{ display: "flex" }}>
      <AccountingField
        label={"Subject"}
        type={"text"}
        name={`invoices[${index}].subject`}
        disabled={true}
      />
      <AccountingField
        label={"Date Referred"}
        type={"date"}
        name={`invoices[${index}].date_referred`}
        disabled={true}
      />
      {/* <AccountingField
        label={"Invoice #"}
        type={"text"}
        name={`invoices[${index}].invoice_id`}
        disabled={true}
      /> */}
      <AccountingField
        label={"File Type"}
        type={"text"}
        name={`invoices[${index}].file_type`}
        disabled={true}
      />
      <AccountingField
        label={"Client File #"}
        type={"text"}
        name={`invoices[${index}].client_file_no`}
        disabled={true}
      />
    </div>
  );
}

export default AccountingHeader;
